module.exports = __webpack_public_path__ + "img/mobile-form.3cb52f83.png";